"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemeMap = exports.defaultSchemes = exports.ipaTranslit = exports.arArabizi = exports.viTelex = exports.eoXsystem = exports.kaTranslit = exports.hyTranslit = exports.heTranslit = exports.elTranslit = exports.srTranslit = exports.mkTranslit = exports.beTranslit = exports.bgTranslit = exports.ukTranslit = exports.ruPhonetic = exports.ruTranslit = void 0;
const ru_translit_1 = require("./ru-translit");
Object.defineProperty(exports, "ruTranslit", { enumerable: true, get: function () { return ru_translit_1.ruTranslit; } });
const ru_phonetic_1 = require("./ru-phonetic");
Object.defineProperty(exports, "ruPhonetic", { enumerable: true, get: function () { return ru_phonetic_1.ruPhonetic; } });
const uk_translit_1 = require("./uk-translit");
Object.defineProperty(exports, "ukTranslit", { enumerable: true, get: function () { return uk_translit_1.ukTranslit; } });
const bg_translit_1 = require("./bg-translit");
Object.defineProperty(exports, "bgTranslit", { enumerable: true, get: function () { return bg_translit_1.bgTranslit; } });
const be_translit_1 = require("./be-translit");
Object.defineProperty(exports, "beTranslit", { enumerable: true, get: function () { return be_translit_1.beTranslit; } });
const mk_translit_1 = require("./mk-translit");
Object.defineProperty(exports, "mkTranslit", { enumerable: true, get: function () { return mk_translit_1.mkTranslit; } });
const sr_translit_1 = require("./sr-translit");
Object.defineProperty(exports, "srTranslit", { enumerable: true, get: function () { return sr_translit_1.srTranslit; } });
const el_translit_1 = require("./el-translit");
Object.defineProperty(exports, "elTranslit", { enumerable: true, get: function () { return el_translit_1.elTranslit; } });
const he_translit_1 = require("./he-translit");
Object.defineProperty(exports, "heTranslit", { enumerable: true, get: function () { return he_translit_1.heTranslit; } });
const hy_translit_1 = require("./hy-translit");
Object.defineProperty(exports, "hyTranslit", { enumerable: true, get: function () { return hy_translit_1.hyTranslit; } });
const ka_translit_1 = require("./ka-translit");
Object.defineProperty(exports, "kaTranslit", { enumerable: true, get: function () { return ka_translit_1.kaTranslit; } });
const eo_xsystem_1 = require("./eo-xsystem");
Object.defineProperty(exports, "eoXsystem", { enumerable: true, get: function () { return eo_xsystem_1.eoXsystem; } });
const vi_telex_1 = require("./vi-telex");
Object.defineProperty(exports, "viTelex", { enumerable: true, get: function () { return vi_telex_1.viTelex; } });
const ar_arabizi_1 = require("./ar-arabizi");
Object.defineProperty(exports, "arArabizi", { enumerable: true, get: function () { return ar_arabizi_1.arArabizi; } });
const ipa_translit_1 = require("./ipa-translit");
Object.defineProperty(exports, "ipaTranslit", { enumerable: true, get: function () { return ipa_translit_1.ipaTranslit; } });
/** Schemes shipped by default, ordered roughly by reader population. */
exports.defaultSchemes = [
    ru_translit_1.ruTranslit,
    ru_phonetic_1.ruPhonetic,
    uk_translit_1.ukTranslit,
    bg_translit_1.bgTranslit,
    be_translit_1.beTranslit,
    mk_translit_1.mkTranslit,
    sr_translit_1.srTranslit,
    el_translit_1.elTranslit,
    he_translit_1.heTranslit,
    hy_translit_1.hyTranslit,
    ka_translit_1.kaTranslit,
    ar_arabizi_1.arArabizi,
    vi_telex_1.viTelex,
    eo_xsystem_1.eoXsystem,
    ipa_translit_1.ipaTranslit,
];
/** Build a `Map<id, scheme>` from an iterable of schemes. */
const schemeMap = (schemes) => {
    const m = new Map();
    for (const s of schemes)
        m.set(s.id, s);
    return m;
};
exports.schemeMap = schemeMap;
